import { Paper, styled } from '@/core/ui';
import { shouldNotForwardProps } from '@/shared/helpers';
export const GroupedListItemPaper = styled(Paper, shouldNotForwardProps('withBackdrop'))(({ theme, withBackdrop }) => ({
    padding: 0,
    marginBottom: theme.spacing(4),
    gap: 0,
    boxShadow: theme.shadows[10],
    ...(withBackdrop && {
        position: 'relative',
    }),
}));
